import { render } from "./PhoneInput.vue?vue&type=template&id=24a34780&scoped=true&bindings={\"modelValue\":\"props\",\"id\":\"props\",\"remove\":\"props\",\"value\":\"data\",\"focus\":\"data\",\"phoneTypes\":\"data\",\"onRemove\":\"options\",\"onInput\":\"options\",\"onFocus\":\"options\",\"onBlur\":\"options\",\"onDropdownHide\":\"options\",\"filled\":\"options\"}"
import script from "./PhoneInput.vue?vue&type=script&lang=js"
export * from "./PhoneInput.vue?vue&type=script&lang=js"

import "./PhoneInput.vue?vue&type=style&index=0&id=24a34780&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-24a34780"

export default script